const authHeaderV2: any = () => {
  const token = localStorage.getItem("token");
  if (token !== null && token !== "" && token !== undefined) {
    return {
      Authorization: `Bearer ${token}`,
      "x-access-token": token,
    };
  } else {
    return {};
  }
};

export default authHeaderV2;
